enum WSRoomNames {
  DMA_APP_IA_ROOM_NAME_BASE = 'dma-app-ia-incident-',
  DMA_APP_PARENT_ROOM_NAME_IA = 'dma-app-ia',
  DMA_APP_PA_ROOM_NAME_BASE = 'dma-app-pa-incident-',
  DMA_APP_PARENT_ROOM_NAME_PA = 'dma-app-pa',
}

export default WSRoomNames;
